export default __webpack_public_path__ + "static/media/minus.8eb41f13.svg";